<template>
  <v-dialog v-model="showDialog" :width="width" persistent>
    <v-card
      ><v-card-title class="headline">Confirm</v-card-title>
      <v-card-text>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.native="declineAction" :disabled="loading" color="info" style="color:white !important">Cancel</v-btn>
        <v-btn
          @click.native="confirmAction"
          :disabled="loading"
          :loading="loading"
          color="primary"
          style="color: white !important"
          >Proceed
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    showDialog: {
      default: false,
    },
    confirmAction: {
      type: Function,
    },
    loading: {
      default: false,
    },
    closeDialog: {
      type: Function,
    },
    width: {
      type: Number,
      default: 290,
    },
  },

  methods: {
    declineAction() {
      this.closeDialog();
    },
  },
};
</script>

<style scoped></style>
